import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "user-role-list" }
const _hoisted_2 = {
  key: 0,
  class: "not-searched"
}
const _hoisted_3 = {
  key: 1,
  class: "not-searched"
}
const _hoisted_4 = { class: "table-scrollbar" }
const _hoisted_5 = { class: "table-header-row" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { colspan: "9" }
const _hoisted_9 = { class: "modal-header justify-content-center pt-3" }
const _hoisted_10 = { class: "row mr-3 ml-3 pl-5 v-theme--light" }
const _hoisted_11 = { class: "d-flex justify-content-end m-3" }

import { formatDateTime } from "@/services/functions";
import ResizableList from '@/components/ResizableList.vue';
import {
  MANAGEMENT_OFFICE,
  SUB_MANAGEMENT_OFFICE,
  INSTALLATION_OFFICE,
  OPERATION_OFFICE,
  DEPARTMENT
} from "@/services/consts/user_role";
import Api from "@/services/api/ApiServiceFabrick"
import { useAuth } from "@/services/user/Auth0UserProvider"
import 'gitart-vue-dialog/dist/style.css'
import { GDialog } from 'gitart-vue-dialog'
import { ref } from 'vue'
import getUserRolesResponseType from "@/types/responses/getUserRoles"
import i18n from '@/lang/i18n';
import EditLinkIcon from "@/components/Common/EditLinkIcon.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'UserRoleList',
  props: {
    isLoading: { type: Boolean },
    isSearchCompleted: { type: Boolean },
    deleteAuthority: { type: Boolean },
    showFlash: { type: Function },
    userRoles: {}
  },
  emits: ["deleteUserRole"],
  setup(__props: any, { emit: __emit }) {

const { loginWithRedirect } = useAuth()

const dialogState = ref(false)
const updatingStatus= ref(false)
const deleteItemId= ref(null as number | null)
const errorMessages = ref({} as {id: string[], full_name: string[]})

const props = __props
const emit = __emit

const HEADER = ([
  i18n.global.t('pages.userRoles.listHeader.roleName'),
  i18n.global.t('pages.userRoles.listHeader.officeableType'),
  i18n.global.t('pages.userRoles.listHeader.officeName'),
  i18n.global.t('pages.userRoles.listHeader.departmentName'),
  i18n.global.t('pages.userRoles.listHeader.updatedAt'),
  i18n.global.t('pages.userRoles.listHeader.updatedBy'),
  i18n.global.t('pages.userRoles.listHeader.form'),
  i18n.global.t('pages.userRoles.listHeader.delete'),
])

function deleteUserRole () {
  if(!deleteItemId.value) return
  updatingStatus.value = true
  Api().deleteUserRoleForm(deleteItemId.value).then((data: {status:boolean}) => {
    updatingStatus.value = false
    if(deleteItemId.value) {
      emit('deleteUserRole', deleteItemId.value)
    }
    closeModal()
    props.showFlash(i18n.global.t('pages.common.messages.removeSuccess'), "success", true)
  }).catch((error: any) => {
    updatingStatus.value = false
    return errorHandle(error.response)
  })
}

function errorHandle (res: any) {
  switch (res.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      break
    case 403:
      props.showFlash(i18n.global.t('pages.common.messages.forbidden'), "error", true)
      break
    case 422:
      errorMessages.value = res.data.errors
  }
}

function convertOrganizationType(organization_type: string){
  let convertedType = {} as {id: number, name: string, type: string} | undefined
  const organizations = [
    MANAGEMENT_OFFICE,
    SUB_MANAGEMENT_OFFICE,
    INSTALLATION_OFFICE,
    OPERATION_OFFICE,
    DEPARTMENT
  ]

  if (organization_type == DEPARTMENT.type) {
    return OPERATION_OFFICE.name
  } else {
    convertedType = organizations.find((object) => {
      return organization_type == object.type
    })
  }
  return convertedType? convertedType.name:""
}

function openModal(id: number) {
  deleteItemId.value = id
  dialogState.value = true
  errorMessages.value = {id: [], full_name: []}
}
function closeModal() {
  deleteItemId.value = null
  dialogState.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!props.isSearchCompleted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.runFilter')), 1)
          ]))
        : _createCommentVNode("", true),
      (props.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.reading')), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(ResizableList, { scrollAreaSelector: ".v-table__wrapper" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_table, null, {
              default: _withCtx(() => [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_5, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(HEADER, (item, index) => {
                      return _createElementVNode("th", { key: item }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(index === 0 ? 'ml-2' : '')
                        }, _toDisplayString(item), 3)
                      ])
                    }), 64))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (props.userRoles?.length != 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.userRoles, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(item.display_name), 1),
                          _createElementVNode("td", null, _toDisplayString(convertOrganizationType(item.organization_type)), 1),
                          _createElementVNode("td", null, _toDisplayString(item.company_name), 1),
                          _createElementVNode("td", null, _toDisplayString(item.department_name), 1),
                          _createElementVNode("td", null, _toDisplayString(_unref(formatDateTime)(new Date(item.updated_at))), 1),
                          _createElementVNode("td", null, _toDisplayString(item.account?.full_name), 1),
                          _createElementVNode("td", null, [
                            _createVNode(EditLinkIcon, {
                              name: 'userRoleForm',
                              id: item.id
                            }, null, 8, ["id"])
                          ]),
                          _createElementVNode("td", null, [
                            (props.deleteAuthority)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: ($event: any) => (openModal(item.id)),
                                  class: "d-flex material-symbols-outlined"
                                }, " delete ", 8, _hoisted_6))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    : (props.isSearchCompleted && !props.isLoading)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                          _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(i18n).global.t('pages.common.list.noData')), 1)
                        ]))
                      : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(GDialog), {
      modelValue: dialogState.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogState).value = $event)),
      "max-width": "20%",
      transition: "custom-from-bottom-transition"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('common.confirmationModal.title')), 1)
        ]),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(i18n).global.t('pages.userRoles.modal.message')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errorMessages.value.id, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item,
            class: "ml-3 pl-5 text-error"
          }, _toDisplayString(item), 1))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errorMessages.value.full_name, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item,
            class: "ml-3 pl-8 text-error"
          }, _toDisplayString(item), 1))
        }), 128)),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_v_btn, {
            class: "m-1 reset-btn",
            onClick: closeModal,
            disabled: updatingStatus.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.userRoles.modal.cancelBtn')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_v_btn, {
            class: "m-1 exec-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteUserRole())),
            loading: updatingStatus.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.userRoles.modal.submitBtn')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})